
































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import T from '../../lang';
import country_Flag from '../CountryFlag.vue';
import user_BasicInfo from './BasicInfov2.vue';
import user_Username from './Username.vue';
import user_Charts from './Chartsv2.vue';
import user_Heatmap from './UserHeatmap.vue';
import user_MainInfo from './MainInfo.vue';
import badge_List from '../badge/List.vue';
import common_GridPaginator from '../common/GridPaginator.vue';
import common_TablePaginator from '../common/TablePaginator.vue';
import { types } from '../../api_types';
import * as Highcharts from 'highcharts/highstock';
import * as ui from '../../ui';
import {
  Problem,
  ContestResult,
  Contest,
  Course,
} from '../../linkable_resource';

export enum ViewProfileTabs {
  Badges = 'badges',
  Problems = 'problems',
  Contests = 'contests',
  CreatedContent = 'created-content',
  Data = 'data',
  Charts = 'charts',
}

function getInitialSelectedTab(
  profile: types.UserProfileInfo,
  selectedTab: string | null,
): string {
  if (!profile.is_own_profile && profile.is_private) {
    return ViewProfileTabs.Data;
  }
  return selectedTab ?? ViewProfileTabs.Badges;
}

@Component({
  components: {
    'omegaup-user-basicinfo': user_BasicInfo,
    'omegaup-user-username': user_Username,
    'omegaup-user-charts': user_Charts,
    'omegaup-user-heatmap': user_Heatmap,
    'omegaup-user-maininfo': user_MainInfo,
    'omegaup-badge-list': badge_List,
    'omegaup-grid-paginator': common_GridPaginator,
    'omegaup-table-paginator': common_TablePaginator,
    'omegaup-countryflag': country_Flag,
  },
})
export default class ViewProfile extends Vue {
  @Prop() data!: types.ExtraProfileDetails | null;
  @Prop() profile!: types.UserProfileInfo;
  @Prop() profileBadges!: Set<string>;
  @Prop() visitorBadges!: Set<string>;
  @Prop({ default: null }) selectedTab!: string | null;
  @Prop({ default: () => [] }) availableYears!: number[];
  contests = Object.values(
    this.data?.contests ?? ({} as types.UserProfileContests),
  )
    .map((contest) => {
      const now = new Date();
      if (contest.place === null || now <= contest.data.finish_time) {
        return null;
      }
      return new ContestResult(contest);
    })
    .filter((contest) => Boolean(contest));
  charts: types.UserProfileStats[] = this.data?.stats ?? [];
  ViewProfileTabs = ViewProfileTabs;
  T = T;
  ui = ui;
  columns = 3;
  currentSelectedTab = getInitialSelectedTab(this.profile, this.selectedTab);
  normalizedRunCounts: Highcharts.PointOptionsObject[] = [];

  get createdContests(): Contest[] {
    if (!this.data?.createdContests) return [];
    let contests = this.data.createdContests;
    if (!this.profile.is_own_profile) {
      contests = contests.filter(
        (contest) => contest.admission_mode === 'public',
      );
    }
    return contests.map((contest) => new Contest(contest));
  }
  get createdCourses(): Course[] {
    if (!this.data?.createdCourses) return [];
    let courses = this.data.createdCourses;
    if (!this.profile.is_own_profile) {
      courses = courses.filter((course) => course.admission_mode === 'public');
    }
    return courses.map((course) => new Course(course));
  }
  get createdProblems(): Problem[] {
    if (!this.data?.createdProblems) return [];
    return this.data.createdProblems.map((problem) => new Problem(problem));
  }
  get unsolvedProblems(): Problem[] {
    if (!this.data?.unsolvedProblems) return [];
    return this.data.unsolvedProblems.map((problem) => new Problem(problem));
  }

  get columnNames(): Array<{ name: string; style: string }> {
    return [
      { name: T.profileContestsTableContest, style: 'text-left' },
      { name: T.profileContestsTablePlace, style: 'text-right' },
    ];
  }

  get solvedProblems(): Problem[] {
    if (!this.data?.solvedProblems) return [];
    return this.data.solvedProblems.map((problem) => new Problem(problem));
  }
  get rank(): string {
    switch (this.profile.classname) {
      case 'user-rank-beginner':
        return T.profileRankBeginner;
      case 'user-rank-specialist':
        return T.profileRankSpecialist;
      case 'user-rank-expert':
        return T.profileRankExpert;
      case 'user-rank-master':
        return T.profileRankMaster;
      case 'user-rank-international-master':
        return T.profileRankInternationalMaster;
      default:
        return T.profileRankUnrated;
    }
  }

  @Watch('currentSelectedTab')
  onCurrentSelectedTabChanged(newValue: string) {
    this.$emit('update:selectedTab', newValue);
  }
}
